import styled from 'styled-components'
const Wrapper = styled.div`
video {
    height: 24rem;
    width: 100%;
}

@media (max-width: 768px) {
    video {
        height: auto;
    }
        .card-body {
    padding: 10px 10px !important;
}

}


.result-content {
    height: 18rem;
    overflow-y: scroll;
    padding: 0rem;
    background: #e2f4f9;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin-inline: 0.3rem;
}



.content-output-container {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    border: 1px solid rgb(0, 103, 182);
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    background: linear-gradient(135deg, rgb(214, 242, 255), rgb(158, 214, 248), rgb(105, 182, 240));
}

audio {
        width: -webkit-fill-available;
    }

    .btn-conainer{
        display: flex;
        gap: 1rem;
    }


    .dropdown-submenu {
  position: relative;
}


    .card-heading{
    color: #374151;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.bg-danger-cus{
    border-radius: 12px;
    border: 1px solid #FDE2E1;
    background: #FEF1F2;
}
.card-heading text-center{
    display: flex;
    justify-content: space-between;
}


@media (max-width: 768px) {
  .first-final-text{
    font-size: 14px !important;
    width: 6rem;
  }
    .first-final-icon svg{
      font-size : 1.2rem!important;
}
}

.content-output-text{
    display: flex;
    align-items: center;
    gap: 1rem;
}
.icons-actions{
    display: flex;
    gap: 2rem;
    }
    .first-final-icon {
        display: flex;
        padding: 11.5px;
        flex-direction: column;
        align-items: flex-start;
        gap: 3.75px;
        border-radius: 18.75px;
        background: #F3F3F3;ss
      }
    .first-final-icon svg{
        font-size : 1.5rem
    }

    .first-final-text{
        margin-bottom: 0;
    color: #374151;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    }

    .icons-actions svg{
        font-size : 1.2rem;
    }


    .icons-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.icon-with-label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
  background-color: transparent;

  svg {
    font-size: 18px;
  }

  .icon-label {
    max-width: 0;
    opacity: 0;
    transition: max-width 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
    font-size: 17px;
    color: #333;
    white-space: nowrap;
    letter-spacing :1px;
  }

  &:hover .icon-label {
    max-width: 100px;
    opacity: 1;
  }

  &:hover {
    background-color: #f0f0f0;
  }
}

.translate-icon-group {
  position: relative;

  .down-arrow {
    font-size: 14px;
  }


 .preview-area {
    border: 2px dashed #ccc;
    padding: 1rem;
    background: #f9f9f9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

 `
  export default Wrapper